import { EnvName } from '@utils/api';
import { ExperimentId, IExperiment } from './types';

const { PRODUCTION, SANDBOX, DEV, LOCAL, TEST, NONE } = EnvName;

export const experiments: IExperiment[] = [
	{
		id: ExperimentId.OIDC,
		env: {
			[PRODUCTION]: true, // `true` = toggle off, but allow to enable with url param: `?experiment:oidc=true`
			[SANDBOX]: 'always',
			[DEV]: 'always',
			[LOCAL]: 'always',
			[TEST]: 'always',
			[NONE]: false
		}
	}
];
